import { render, staticRenderFns } from "./BtnBack.vue?vue&type=template&id=1c19a867"
import script from "./BtnBack.vue?vue&type=script&lang=js"
export * from "./BtnBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports